import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-ink text-paper">
                <p className="font-mono text-xs uppercase tracking-widest opacity-60">Loading admin…</p>
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
    return children;
}
